document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('details');

  accordions.forEach(details => {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.accordion__content');

    if (!summary || !content) return;

    // Handle pre-opened accordions on page load
    if (details.hasAttribute('open')) {
      content.style.maxHeight = content.scrollHeight + 'px';
    }

    summary.addEventListener('click', e => {
      e.preventDefault();

      const isOpen = details.hasAttribute('open');

      if (isOpen) {
        // Closing
        content.style.maxHeight = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.maxHeight = '0px';
        });

        content.addEventListener('transitionend', function handler() {
          details.removeAttribute('open');
          content.removeEventListener('transitionend', handler);
        });
      } else {
        // Opening
        // Set open attribute AFTER transition starts
        details.setAttribute('data-opening', 'true'); // flag to avoid instant jump

        // Temporarily show the content without open
        content.style.display = 'block';
        content.style.maxHeight = '0px';

        requestAnimationFrame(() => {
          details.setAttribute('open', ''); // now add open
          content.style.maxHeight = content.scrollHeight + 'px';
        });

        // Clean up: remove inline display after transition
        content.addEventListener('transitionend', function handler() {
          content.style.display = '';
          details.removeAttribute('data-opening');
          content.removeEventListener('transitionend', handler);
        });

        // Optional: Close other accordions
        accordions.forEach(other => {
          if (other !== details && other.hasAttribute('open')) {
            const otherContent = other.querySelector('.accordion__content');
            if (!otherContent) return;

            otherContent.style.maxHeight = otherContent.scrollHeight + 'px';
            requestAnimationFrame(() => {
              otherContent.style.maxHeight = '0px';
            });

            otherContent.addEventListener('transitionend', function handler() {
              other.removeAttribute('open');
              otherContent.removeEventListener('transitionend', handler);
            });
          }
        });
      }
    });

    window.addEventListener('resize', () => {
      if (details.hasAttribute('open')) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
});
